module.exports = __webpack_public_path__ + "img/logo.8c0f04b0.png";